<script setup lang="ts">
import type { RelationReferentUser } from "~/modules/relation/models/RelationReferentUser.interface";

const props = defineProps<{
  referentUser?: RelationReferentUser;
}>();

defineEmits(["changeReferentUser"]);

interface ReferentUserForm {
  lastName: string;
  firstName: string;
  email: string;
}
const referentUserForm = reactive<ReferentUserForm>({
  lastName: "",
  firstName: "",
  email: "",
});

const inputClass = ["disabled:!bg-white", "disabled:!cursor-default"];
const labelClass = "hover:!cursor-default";

onMounted(() => {
  Object.assign(referentUserForm, {
    lastName: props.referentUser?.lastName,
    firstName: props.referentUser?.firstName,
    email: props.referentUser?.email,
  });
});
</script>

<template>
  <div class="border border-gray-400 rounded-lg px-4 pt-4 w-4/5">
    <lxc-form-item :label="$t('user.lastName')" hide-optional disabled>
      <lxc-input
        v-model="referentUserForm.lastName"
        type="text"
        :class="inputClass"
        :label-class="labelClass"
      />
    </lxc-form-item>

    <lxc-form-item :label="$t('user.firstName')" hide-optional disabled>
      <lxc-input
        v-model="referentUserForm.firstName"
        type="text"
        :class="inputClass"
        :label-class="labelClass"
      />
    </lxc-form-item>

    <lxc-form-item :label="$t('user.email')" hide-optional disabled>
      <lxc-input
        v-model="referentUserForm.email"
        type="text"
        :class="inputClass"
        :label-class="labelClass"
      />
    </lxc-form-item>
  </div>

  <div class="mt-6">
    <lxc-button
      :text="$t('administration.relations.contact.referentUser.modified')"
      :title="$t('administration.relations.contact.referentUser.modified')"
      type="secondary"
      @click="$emit('changeReferentUser')"
    />
  </div>
</template>
